import React from 'react'
import "./styles.css";

const Loading = ({padTop=true}) => {
  return (
    <div className={`flex flex-jc-c ${padTop ? " mt-5" : ""}`}>
    <div className="flex flex-dc flex-jc-c flex-ai-c mt-5 ">
      <i className="fas fa-spinner fa-pulse mb-1 fa-2x"></i>
      <small> Just a moment</small>
    </div>
    </div>
  )
}

export default Loading


export const CustomLoading = ({ text }) => {
  return (
    <>
      <div className="loading-icon-container">
        <div className="dot-pulse"></div>
        <small className="text-center mt-1 loader-text">{text}</small>
      </div>
    </>
  );
};




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/Loading/index.js